/*
=====================================================================
  ENLACES DE LA LANDING · REGALOS CORPORATIVOS MÜNN Y WISH
=====================================================================

INSTRUCCIONES:

1. Copia el nuevo enlace público del catálogo.
2. Reemplaza únicamente el texto que está entre comillas después de catalogUrl.
3. No borres las comillas, la coma ni los demás códigos.
4. Guarda el archivo.
5. Vuelve a publicar la landing.

No necesitas modificar ningún otro archivo.

Para el enlace de productos WISH haz lo mismo, pero en la línea wishUrl.
=====================================================================
*/

window.LANDING_CONFIG = {
  catalogUrl: "https://drive.google.com/file/d/1cJGts3Ki8AwO7fJCfhuYDb6bQJivtNLL/preview",
  wishUrl: "https://www.makeawish.co"
};